import { type PayeeFilterInput, type PayeeType } from "#graphql/supergraphTypes";

export type PayeeFilterModel = {
  clientName?: string | null;
  payeeName?: string | null;
  payeeType?: PayeeType[] | null;
};

export type ExtendedPayeeFilterInput = PayeeFilterInput & {
  payeeTypes?: PayeeType[];
};

export const applyPayeeFilter = (
  inputFilter: ExtendedPayeeFilterInput,
  filterModel: PayeeFilterModel,
) => {
  const { clientName, payeeName, payeeType } = filterModel;

  if (clientName) {
    inputFilter.arenaIds = [clientName];
  }

  if (payeeName) {
    inputFilter.searchTerm = payeeName;
  }

  if (payeeType && payeeType.length > 0) {
    inputFilter.payeeTypes = payeeType;
  }
};
